import Insto1 from "../assets/insto-1.png";
import Insto2 from "../assets/insto-2.png";
import Insto3 from "../assets/insto-3.png";
import { GAME_CONFIG } from "../config";

let usedInsto = GAME_CONFIG.hasPrepStage
  ? {
      0: Insto1,
      1: Insto1,
      2: Insto2,
      3: Insto3,
    }
  : {
      0: Insto1,
      1: Insto2,
      2: Insto3,
    };

export default function getFoundInstos(foundHotspots, currentStage) {
  let foundInstos = [];
  for (let i = 1; i <= foundHotspots[currentStage]; i++) {
    if (i <= 3) {
      foundInstos.push(
        <img
          key={"insto-img-" + i}
          className="found-insto-img"
          src={usedInsto[currentStage]}
        />
      );
    }
  }

  return foundInstos;
}
